// Product page warning when adding to cart
document.addEventListener('DOMContentLoaded', function() {
  // Only run on product pages with t-shirts tag
  if (!document.querySelector('.product-form')) return;
  
  const addToCartButton = document.querySelector('button[name="add"]');
  const productForm = document.querySelector('form[action*="/cart/add"]');
  
  if (!addToCartButton || !productForm) return;
  
  // Intercept add to cart
  productForm.addEventListener('submit', function(e) {
    const decorationInputs = document.querySelectorAll('input[name*="Decoration Method"]:checked');
    const quantityInput = document.querySelector('input[name="quantity"]');
    
    if (!decorationInputs.length || !quantityInput) return;
    
    const decoration = decorationInputs[0].value;
    const qty = parseInt(quantityInput.value) || 1;
    
    let minimum = 0;
    let decorationType = '';
    
    if (decoration.toLowerCase().includes('embroidery')) {
      minimum = 8;
      decorationType = 'Embroidery';
    } else if (decoration.toLowerCase().includes('silk screen') || decoration.toLowerCase().includes('screen print')) {
      minimum = 25;
      decorationType = 'Silk Screen';
    }
    
    // Show reminder if below minimum
    if (minimum > 0 && qty < minimum) {
      const needed = minimum - qty;
      setTimeout(function() {
        alert(`✓ Item added to cart!\n\n⚠️ REMINDER: ${decorationType} requires a minimum of ${minimum} pieces total.\n\nYou've added ${qty} piece${qty !== 1 ? 's' : ''}.\nYou need ${needed} more piece${needed !== 1 ? 's' : ''} to reach the minimum.\n\nFeel free to mix sizes! Add more items before checkout.`);
      }, 300);
    } else if (minimum > 0) {
      // They met or exceeded minimum
      setTimeout(function() {
        alert(`✓ Item added to cart!\n\n${qty} piece${qty !== 1 ? 's' : ''} of ${decorationType} added. Minimum requirement met! ✓`);
      }, 300);
    }
  });
});